import { FORMATS } from './types';

export const fetchFormats = () => ({
  type: FORMATS.GET,
});
